import { StyledStepSection } from './StepSection.styles';
import { Heading, Types, RichText, Icon } from '@marriott/mi-ui-library';
import { StepSectionProps } from './StepSection.types';
import clsx from 'clsx';

export const StepSection = (props: StepSectionProps) => {
  return (
    <StyledStepSection className={clsx('d-flex flex-column')}>
      <Icon iconClass={`${props?.iconClass} step-section__icon`} ariaLabel={props?.iconClass} />

      <Heading
        variation={Types.headingType.subtitle}
        titleText={props?.title}
        fontSize={Types.size.medium}
        element={Types.tags.span}
        customClass="mb-1"
      />

      <RichText
        componentId={`${props?.title} - description`}
        customClass="t-font-alt-s step-section__description"
        text={props?.description}
      />
    </StyledStepSection>
  );
};

export default StepSection;
